import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_19 = { class: "d-block text-body-tertiary fw-normal" }
const _hoisted_20 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_25 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_29 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_34 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = { class: "form-check form-group form-switch mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "is_notifiable"
}
const _hoisted_40 = {
  key: 1,
  class: "col-sm-6 col-xl-4"
}
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25 w-auto" }
const _hoisted_42 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_43 = ["required"]
const _hoisted_44 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_45 = {
  key: 2,
  class: "col-sm-6 col-xl-4"
}
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25 w-auto" }
const _hoisted_47 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_48 = ["required"]
const _hoisted_49 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_52 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_53 = {
  key: 0,
  class: "text-success"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-check-circle" }, null, -1 /* HOISTED */)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_57 = {
  key: 3,
  class: "col-12"
}
const _hoisted_58 = {
  key: 4,
  class: "col-md-12"
}
const _hoisted_59 = { class: "d-flex align-items-center justify-content-between gap-3 mb-25" }
const _hoisted_60 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_62 = { class: "position-relative" }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_65 = {
  key: 5,
  class: "accordion border-0",
  id: "step-form-accordion"
}
const _hoisted_66 = { class: "accordion-item block-form border-0 rounded-0 border-0" }
const _hoisted_67 = ["data-bs-target", "aria-controls"]
const _hoisted_68 = { class: "d-sm-flex align-items-center justify-content-between pe-3" }
const _hoisted_69 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_70 = { class: "block-handle fw-bold text-muted" }
const _hoisted_71 = { class: "fw-medium text-black-emphasis mb-0 flex-grow-1" }
const _hoisted_72 = { class: "text-muted text-uppercase small badge bg-light" }
const _hoisted_73 = ["id"]
const _hoisted_74 = { class: "border-0 mt-20 py-15 py-sm-20 py-sm-25 py-lg-30" }
const _hoisted_75 = {
  key: 6,
  class: "d-flex justify-content-between gap-3 mt-25 flex-wrap"
}
const _hoisted_76 = { class: "mb-8" }
const _hoisted_77 = { class: "row justify-content-center" }
const _hoisted_78 = { class: "col" }
const _hoisted_79 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_StepForm = _resolveComponent("StepForm")!
  const _component_DraggableList = _resolveComponent("DraggableList")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_SurveyStepModal = _resolveComponent("SurveyStepModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" LANG "),
            (_ctx.update)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.locales.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('feature.contents.lang')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_country_flag, {
                            country: _ctx.lang,
                            size: "big"
                          }, null, 8 /* PROPS */, ["country"]),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select shadow-none text-black p-15 pe-50 fs-14 fw-medium w-auto",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lang) = $event)),
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLang())),
                            required: ""
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: locale,
                                key: locale
                              }, _toDisplayString(_ctx.$t(`feature.contents.$lang.${locale}`)), 9 /* TEXT, PROPS */, _hoisted_8))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelSelect, _ctx.lang]
                          ])
                        ]),
                        _createCommentVNode(" ERRORS "),
                        (_ctx.errors?.lang ?? false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lang, (error) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: error,
                                  class: "small text-danger lh-1 m-0 mt-1"
                                }, _toDisplayString(error), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_10,
            _createCommentVNode(" NAME "),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('form.title.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.survey.title![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.title }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.survey.title![_ctx.lang]]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.title ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.title, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_15,
            _createCommentVNode(" KEY "),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.key.label')) + "* ", 1 /* TEXT */),
                  _createElementVNode("small", _hoisted_19, _toDisplayString(_ctx.$t('feature.surveys.key_recommendations')), 1 /* TEXT */)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.survey.key) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.key }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.survey.key]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.key ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.key, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_21,
            _createCommentVNode(" DESCRIPTION "),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('form.description.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.survey.description![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.description }]]),
                  rows: "6"
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.survey.description![_ctx.lang]]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.description ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.description, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" FOOTER TEXT "),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('form.footer.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.survey.footer_text![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.footer_text }]]),
                  rows: "6"
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.survey.footer_text![_ctx.lang]]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.footer_text ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.footer_text, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_30,
            _createCommentVNode(" FREQUENCY "),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('feature.surveys.frequency')) + "* ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_34, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select shadow-none text-black p-15 pe-50 fs-14 fw-medium w-auto",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.survey.frequency) = $event)),
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequencies, (key) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: key,
                        key: key
                      }, _toDisplayString(_ctx.$t(`feature.surveys.$frequency.${key}`)), 9 /* TEXT, PROPS */, _hoisted_35))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.survey.frequency]
                  ])
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.frequency ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.frequency, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" IS NOTIFIABLE "),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input shadow-none me-8",
                  type: "checkbox",
                  role: "switch",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.survey.is_notifiable) = $event)),
                  id: "is_notifiable",
                  "true-value": 1,
                  "false-value": 0
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.survey.is_notifiable]
                ]),
                _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('feature.surveys.is_notifiable')), 1 /* TEXT */)
              ])
            ]),
            _createCommentVNode(" FREQUENCY DAYS "),
            (_ctx.survey.is_notifiable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('feature.surveys.default_frequency_days')) + "* ", 1 /* TEXT */),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.survey.default_frequency_days) = $event)),
                      type: "number",
                      class: _normalizeClass(["form-control shadow-none text-black w-auto", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.default_frequency_days }]]),
                      required: _ctx.survey.is_notifiable
                    }, null, 10 /* CLASS, PROPS */, _hoisted_43), [
                      [_vModelText, _ctx.survey.default_frequency_days]
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.default_frequency_days ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.default_frequency_days, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" FREQUENCY TIME "),
            (_ctx.survey.is_notifiable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('feature.surveys.default_notification_time')) + "* ", 1 /* TEXT */),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.survey.default_notification_time) = $event)),
                      pattern: "[0-9]{2}:[0-9]{2}",
                      type: "time",
                      required: _ctx.survey.is_notifiable,
                      class: _normalizeClass(["form-control shadow-none text-black w-auto", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.default_notification_time }]])
                    }, null, 10 /* CLASS, PROPS */, _hoisted_48), [
                      [_vModelText, _ctx.survey.default_notification_time]
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.default_notification_time ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.default_notification_time, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" EXTRAS "),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("label", _hoisted_52, [
                  _createTextVNode(_toDisplayString(_ctx.$t('feature.surveys.extra')) + " ", 1 /* TEXT */),
                  (_ctx.survey.extra !== undefined)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, [..._hoisted_55]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("code", null, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.local_extra) = $event)),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.extra }]]),
                    rows: "6"
                  }, null, 2 /* CLASS */), [
                    [_vModelText, _ctx.local_extra]
                  ])
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.extra ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.extra, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" <div class=\"col-12\">\n                        <div class=\"form-group mb-15 mb-sm-20 mb-md-25 w-auto\">\n                            <label class=\"d-block text-black fw-semibold mb-10\">\n                                {{ $t('feature.surveys.extra') }}\n                            </label>\n                            <div class=\"row align-items-center\" v-for=\"(extra, index) in extras\" :key=\"index\">\n                                <div class=\"col-sm-6 col-md-4 mb-15\">\n                                    <input v-model=\"extras[index][0]\" class=\"form-control shadow-none text-black\" required :placeholder=\"$t('form.key.label')\"/>\n                                </div>\n                                <div class=\"col-sm-6 col-md-4 mb-15\">\n                                    <input v-model=\"extras[index][1]\" class=\"form-control shadow-none text-black\" required :placeholder=\"$t('form.value.label')\"/>\n                                </div>\n                                <div class=\"col-auto mb-30 mb-md-15 ms-auto ms-md-0\">\n                                    <button type=\"button\" @click=\"extras.splice(index, 1)\"\n                                                class=\"bg-transparent p-0 border-0 text-danger lh-1 fw-medium\">\n                                                <span class=\"position-relative\">{{ $t('cta.delete') }}</span>\n                                            </button>\n                                </div>\n                            </div>\n                            <button class=\"default-btn outlined transition fw-medium fs-md-15 fs-lg-16\"\n                                    type=\"button\" v-on:click=\"extras.push(['',undefined])\">\n                                    {{ $t('cta.add') }}\n                            </button>\n                            \n                            <div class=\"form-messages mt-2 px-1\" v-if=\"errors?.extra ?? false\">\n                                <p v-for=\"error in errors.extra\" :key=\"error\"\n                                    class=\"small text-danger lh-1 m-0 mt-1\">\n                                    {{ error }}\n                                </p>\n                            </div>\n                        </div>\n                    </div> "),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createVNode(_component_SpinnerLoading, { class: "mb-25" })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('cta.delete_survey')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_63)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push({ path: '/surveys' })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.save_survey')), 1 /* TEXT */)
                    ])
                  ])
                ])),
            _createCommentVNode(" BLOCKS "),
            (_ctx.survey.steps)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createVNode(_component_DraggableList, {
                    list: _ctx.survey.steps,
                    "item-key": "id",
                    handle: ".block-form .block-handle",
                    sort: "true",
                    onStart: _ctx.dragStart,
                    onChange: _ctx.orderSteps
                  }, {
                    item: _withCtx((step) => [
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("button", {
                          class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0 collapsed p-15 p-sm-20 p-sm-25 p-lg-30 pe-50",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": `#step-tab-${step.element.id}`,
                          "aria-expanded": "false",
                          "aria-controls": `step-tab-${step.element.id}`
                        }, [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, _toDisplayString(step.index + 1), 1 /* TEXT */),
                              _createElementVNode("h5", _hoisted_71, _toDisplayString(step.element.title[_ctx.lang]), 1 /* TEXT */)
                            ]),
                            _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t(`feature.surveys.$steps.$type.${step.element.type}`)), 1 /* TEXT */)
                          ])
                        ], 8 /* PROPS */, _hoisted_67),
                        _createElementVNode("div", {
                          id: `step-tab-${step.element.id}`,
                          class: "accordion-collapse collapse border-0",
                          "data-bs-parent": "#step-form-accordion"
                        }, [
                          _createElementVNode("div", _hoisted_74, [
                            _createCommentVNode(" BODY "),
                            _createCommentVNode(" TODO: SurveyStepForm "),
                            (_openBlock(), _createBlock(_component_StepForm, {
                              step: (step.element as SurveyStep),
                              key: step.element.id,
                              update: true,
                              lang: _ctx.lang,
                              onUpdate: updated => _ctx.updateStep(step.index, updated),
                              onChangeLang: _cache[13] || (_cache[13] = (event) => _ctx.changeLang(event)),
                              onDelete: ($event: any) => (_ctx.deleteStep(step.index))
                            }, null, 8 /* PROPS */, ["step", "lang", "onUpdate", "onDelete"]))
                          ])
                        ], 8 /* PROPS */, _hoisted_73)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["list", "onStart", "onChange"])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode("  "),
            _createCommentVNode(" ADD "),
            (_ctx.update)
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.$t('feature.surveys.$steps.drag_reorder')), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "ms-auto default-btn outlined transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addBlock && _ctx.addBlock(...args)))
                  }, _toDisplayString(_ctx.$t('feature.surveys.$steps.add')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[17] || (_cache[17] = ($event: any) => (_ctx.deleteSurvey())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"]),
    (_ctx.update)
      ? (_openBlock(), _createBlock(_component_SurveyStepModal, {
          key: 0,
          id: "step_modal",
          survey_id: _ctx.survey.id!,
          onSave: _cache[18] || (_cache[18] = event => _ctx.saveStep(event))
        }, null, 8 /* PROPS */, ["survey_id"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" <ConfirmModal @confirm=\"deleteCover()\" :id=\"`deleteCover`\" :title=\"$t('cta.$delete.title')\"\n        :message=\"$t('cta.$delete.message')\" /> ")
  ], 64 /* STABLE_FRAGMENT */))
}